import useUser from "@app/zustand/user";
import { isDemoEmail } from "@app/utils/demo-account";
import { useReadonlyScope } from "@app/utils/use-readonly-scope";

/**
 * Whether the laboratory is only read in this session: the public demo (PT-105), or a reader visiting
 * another speciality (PT-74).
 *
 * The backend refuses every write these sessions make. A button that answers 403 is worse than a
 * button that is not there.
 */
export function useLabReadOnly(): boolean {
  const readonlyScope = useReadonlyScope();
  const email = useUser(
    (state) => (state.user as { email?: string } | null)?.email,
  );
  return readonlyScope || isDemoEmail(email);
}
